module.exports = __webpack_public_path__ + "static/media/likeFacebook.6811e2e9.svg";